import React, { useContext, useRef, useEffect } from 'react'
import AppContext from '../context/app'
import { ESW_CLASSNAMES } from '../../constants'
import classNames from 'classnames'

export default function Subtotal() {
    const { cart, country, prices } = useContext(AppContext)

    function reducer(total, item) {
        const { product_id, qty, } = item
        const price = prices[product_id][country?.countryIso]
        total += price?.price * qty
        return total
    }

    const elRef = useRef(null)
    useEffect(() => {
        if(!elRef || !elRef.current || !country || !cart || !prices) return

        const value = cart?.items.reduce(reducer, 0).toFixed(2)
        const display = `${country?.currencySymbol}${value}`

        elRef.current.innerText = display
    }, [elRef, country, cart, prices])

    return <s
        ref={elRef}
        className={classNames(
            ESW_CLASSNAMES.CART_SUBTOTAL_BEFORE_DISCOUNT,
            'fw-semibold text-secondary',
        )}
        style={{
            fontSize: 18
        }}
    ></s>
}
